import { c as _c } from "react/compiler-runtime";
import CreateWaveOutcomeTypes from "./CreateWaveOutcomeTypes";
import CreateWaveOutcomesManual from "./manual/CreateWaveOutcomesManual";
import CreateWaveOutcomesRep from "./rep/CreateWaveOutcomesRep";
import CreateWaveOutcomesCIC from "./cic/CreateWaveOutcomesCIC";
import CreateWaveOutcomesRows from "./winners/rows/CreateWaveOutcomesRows";
import type { CreateWaveDatesConfig, CreateWaveOutcomeConfig } from "@/types/waves.types";
import { CreateWaveOutcomeType } from "@/types/waves.types";
import CommonAnimationHeight from "@/components/utils/animation/CommonAnimationHeight";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import type { JSX } from "react";
export default function WavesOutcome(t0) {
  const $ = _c(41);
  const {
    outcomes,
    outcomeType,
    waveType,
    errors,
    dates,
    setOutcomeType,
    setOutcomes
  } = t0;
  let t1;
  if ($[0] !== outcomes || $[1] !== setOutcomeType || $[2] !== setOutcomes) {
    t1 = outcome => {
      setOutcomes([...outcomes, outcome]);
      setOutcomeType(null);
    };
    $[0] = outcomes;
    $[1] = setOutcomeType;
    $[2] = setOutcomes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onOutcome = t1;
  let t2;
  if ($[4] !== setOutcomeType) {
    t2 = () => {
      setOutcomeType(null);
    };
    $[4] = setOutcomeType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onCancel = t2;
  let t3;
  if ($[6] !== dates || $[7] !== onCancel || $[8] !== onOutcome || $[9] !== waveType) {
    t3 = <CreateWaveOutcomesManual onOutcome={onOutcome} onCancel={onCancel} dates={dates} waveType={waveType} />;
    $[6] = dates;
    $[7] = onCancel;
    $[8] = onOutcome;
    $[9] = waveType;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== dates || $[12] !== onCancel || $[13] !== onOutcome || $[14] !== waveType) {
    t4 = <CreateWaveOutcomesRep onOutcome={onOutcome} onCancel={onCancel} dates={dates} waveType={waveType} />;
    $[11] = dates;
    $[12] = onCancel;
    $[13] = onOutcome;
    $[14] = waveType;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== dates || $[17] !== onCancel || $[18] !== onOutcome || $[19] !== waveType) {
    t5 = <CreateWaveOutcomesCIC onOutcome={onOutcome} onCancel={onCancel} dates={dates} waveType={waveType} />;
    $[16] = dates;
    $[17] = onCancel;
    $[18] = onOutcome;
    $[19] = waveType;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t6 = {
      [CreateWaveOutcomeType.MANUAL]: t3,
      [CreateWaveOutcomeType.REP]: t4,
      [CreateWaveOutcomeType.NIC]: t5
    };
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  const components = t6;
  let t7;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="tw-mb-0 tw-text-xl tw-font-semibold tw-text-white">Choose outcome type</p>;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== outcomeType || $[27] !== setOutcomeType) {
    t8 = <CreateWaveOutcomeTypes outcomeType={outcomeType} setOutcomeType={setOutcomeType} />;
    $[26] = outcomeType;
    $[27] = setOutcomeType;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== components || $[30] !== errors || $[31] !== outcomeType || $[32] !== outcomes || $[33] !== setOutcomes || $[34] !== waveType) {
    t9 = outcomeType ? components[outcomeType] : <CreateWaveOutcomesRows waveType={waveType} errors={errors} outcomes={outcomes} setOutcomes={setOutcomes} />;
    $[29] = components;
    $[30] = errors;
    $[31] = outcomeType;
    $[32] = outcomes;
    $[33] = setOutcomes;
    $[34] = waveType;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== t9) {
    t10 = <div><CommonAnimationHeight>{t9}</CommonAnimationHeight></div>;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== t10 || $[39] !== t8) {
    t11 = <div className="tw-mx-auto tw-w-full">{t7}<div className="tw-mt-3 tw-space-y-6">{t8}{t10}</div></div>;
    $[38] = t10;
    $[39] = t8;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
}